class LolaTimeline extends HTMLElement {
  constructor() {
    super();
    this.mode = 'desktop';
    this.swiper = null;
    this.boundSetMode = this.setMode.bind(this);
  }

  connectedCallback() {
    this.root = this;
    this.swiperEl = this.querySelector('.section-lola-timeline__swiper');
    this.yearsRow = this.querySelector('.section-lola-timeline__years');
    if (!this.swiperEl || !this.yearsRow) return;

    this.yearButtons = Array.from(this.yearsRow.querySelectorAll('.section-lola-timeline__year'));
    this.slides = Array.from(this.swiperEl.querySelectorAll('.swiper-slide'));

    this.setMode();
    window.addEventListener('resize', this.boundSetMode, { passive: true });

    this.bindYearEvents();
    this.waitForSwiper();
  }

  setMode() {
    this.mode = window.matchMedia('(max-width: 1023px)').matches ? 'mobile' : 'desktop';
    this.dataset.mode = this.mode;
    this.updateMobileHeight();
  }

  updateMobileHeight(speed = 0) {
    if (!this.swiper) return;

    const isMobile = this.mode === 'mobile';
    this.swiper.params.autoHeight = isMobile;

    if (isMobile) {
      this.swiper.updateAutoHeight(speed);
    } else if (this.swiper.wrapperEl) {
      this.swiper.wrapperEl.style.height = '';
    }
  }

  waitForSwiper() {
    const onReady = () => {
      if (this.swiperEl.swiper) {
        this.swiper = this.swiperEl.swiper;
        this.bindSwiperEvents();
        this.updateMobileHeight();
        this.root.classList.add('is-ready');
      } else {
        setTimeout(onReady, 80);
      }
    };
    if (document.readyState === 'complete') {
      onReady();
    } else {
      window.addEventListener('load', onReady, { once: true });
    }
  }

  bindYearEvents() {
    this.yearButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.onYearClick(btn);
      });
    });
  }

  bindSwiperEvents() {
    if (!this.swiper) return;
    this.swiper.on('slideChange', () => this.onSlideChange());
    this.swiper.on('slideChangeTransitionEnd', () => this.onSlideChange());
  }

  indexOf(btn) {
    return parseInt(btn.dataset.index, 10) || 0;
  }

  setActive(index, { lock = false, scrollYear = true } = {}) {
    if (typeof index !== 'number' || isNaN(index)) return;

    this.yearButtons.forEach((btn) => {
      const i = this.indexOf(btn);
      const isActive = i === index;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.root.dataset.activeIndex = String(index);

    if (scrollYear && this.mode === 'mobile') {
      const target = this.yearButtons[index];
      if (target) {
        const left = target.offsetLeft - this.yearsRow.clientWidth / 2 + target.clientWidth / 2;
        this.yearsRow.scrollTo({ left, behavior: 'smooth' });
      }
    }

    if (this.swiper && this.swiper.activeIndex !== index) {
      try {
        this.swiper.slideTo(index, 400);
      } catch (e) {}
    }
  }

  onYearClick(btn) {
    const i = this.indexOf(btn);
    this.setActive(i);
  }

  onSlideChange() {
    if (!this.swiper) return;
    const index = this.swiper.activeIndex;
    this.yearButtons.forEach((btn) => {
      const i = this.indexOf(btn);
      const isActive = i === index;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.root.dataset.activeIndex = String(index);
    this.updateMobileHeight(300);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.boundSetMode);
  }
}

if (!customElements.get('lola-timeline')) {
  customElements.define('lola-timeline', LolaTimeline);
}
